Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  none: 'off',
  creditCardNumber: 'cc-number',
  emailAddress: 'email',
  fullStreetAddress: 'street-address',
  postalCode: 'postal-code',
  telephoneNumber: 'tel',
  username: 'username',
  password: 'password'
};